export default __webpack_public_path__ + "static/media/homer2.84afac08.png";